import { useMemo } from 'react';

import { useFeatureFlag } from './v2';

/**
 * A hook with dynamic feature flags that listens for value changes.
 * Can be used at the global context level to access updated feature flag values
 * across the app.
 */
export const useDynamicFeatureFlags = () => {
  const isBrazeLiveActivitiesEnabled = useFeatureFlag('CELS-3466-braze-live-activities-enabled', { listenForChanges: true }); // prettier-ignore
  const isConfirmExitEnabled = useFeatureFlag('CELS-4275-order-cancel-confirmation-modal-enabled'); // prettier-ignore
  const numberOfUpsellProducts = useFeatureFlag('permanent-order-upsell-number-of-products', { listenForChanges: true }); // prettier-ignore

  return useMemo(
    () => ({
      isBrazeLiveActivitiesEnabled,
      isConfirmExitEnabled,
      numberOfUpsellProducts,
    }),
    [isBrazeLiveActivitiesEnabled, isConfirmExitEnabled, numberOfUpsellProducts],
  );
};
